export default {
    LOAD_COMPANYBRANCH (state, companybranches) {
        state.items = companybranches
    }
}